import { Component } from '@angular/core';
import { IdealProfileCardModel } from './idealprofile-card.model';

@Component({
  selector: 'app-detail-table',
  templateUrl: './idealprofile-card-table.component.html',
  styleUrls: ['../../detail-screen/detail-screen.component.css'],
})
export class IdealProfileTableComponent {
  restrictedData: boolean;
  tableColumns: string[];
  tableData: IdealProfileCardModel[];
  emptyValuePlaceholder = '-';
  errorText: string;
  showTable: boolean;

  constructor() {
    this.tableColumns = [];
    this.tableData = [];
  }
}
